import React, { createContext, useContext, useEffect, useState } from 'react';

const DebugContext = createContext({ debugMode: false, setDebugMode: () => {} });

export function DebugProvider({ children }) {
  const [debugMode, setDebugMode] = useState(false);

  useEffect(() => {
    const url = new URLSearchParams(window.location.search);
    const param = url.get('debug');
    if (param === '1') {
      localStorage.setItem('debugMode', 'true');
      setDebugMode(true);
    } else if (param === '0') {
      localStorage.removeItem('debugMode');
      setDebugMode(false);
    } else {
      setDebugMode(localStorage.getItem('debugMode') === 'true');
    }
  }, []);

  const update = (val) => {
    setDebugMode(val);
    if (val) localStorage.setItem('debugMode', 'true');
    else localStorage.removeItem('debugMode');
  };

  return (
    <DebugContext.Provider value={{ debugMode, setDebugMode: update }}>
      {children}
    </DebugContext.Provider>
  );
}

export const useDebug = () => useContext(DebugContext);
